<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Item</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

                <!-- <div>
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      

                      <div
                        class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="approved_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div> -->
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  @click="saveStatus()"
                  :loading="process.form"
                  :disabled="process.form"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          v-if="dialog.form"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Ubah Item {{ selected.form !== '' ? list[selected.form].item_name : '' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Quantity" 
                    rules="required|min_value:0" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Quantity
                    </div>

                    <v-currency-field              
                      rounded
                      dense
                      filled
                      hide-details

                      color="#718EBF"
                      placeholder="Qty"
                      :error-messages="errors"

                      class="mb-6"

                      v-model="form.qty"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.qty !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>

                  <!-- <ValidationProvider 
                    :name="`Supplier`"
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2">
                      <span class="red--text">*</span>
                      Supplier
                    </div>
                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih salah satu Supplier"
                      hide-details
                      clearable
                      item-text="supplier_name"
                      item-value="supplier_id"
                      :items="supplier"
                      v-model="form.supplier_id"
                      class="mb-6"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.supplier_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider> -->

                  <div class="body-2 mb-2">
                    Catatan
                  </div>
                  <v-textarea
                    filled
                    rounded
                    dense
                    rows="3"
                    
                    hide-details
                    
                    :color="set_color"
                    placeholder="Contoh. Tuliskan catatan disini . . ."

                    v-model="form.note"
                    style="border-radius: 10px;">
                  </v-textarea>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/pembelian/approval-permintaan"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="22"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="fs-16 black--text ml-3"
                    style="font-weight: 600;">
                    Detail Approval Permintaan
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1 pt-0">
            <v-col 
              cols="12"
              class="py-0">
              <div style="height: calc(100vh - 220px); overflow-y: auto;">
                <v-card v-if="process.load && Object.keys(detail).length < 1"
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
  
                <div v-if="!process.load && Object.keys(detail).length > 0" class="px-4">
                  <v-card flat class="mt-0">
                    <v-card-text class="pt-0 px-0">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-card flat style="background: #E1F5FE; border-radius: 10px;" height="100%">
                            <v-card-text>
                              <div class="d-flex">
                                <div class="mb-5">
                                  <div>
                                    No. Permintaan
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    {{ detail.number }}
                                  </div>
                                </div>
                                <div class="mb-5 ml-auto">
                                  <div>
                                    <v-chip
                                      class="ma-0"
                                      :style="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'color: white;' : detail.status === 'Disetujui' ? 'color: white;' : detail.status === 'Diproses' ? 'color: white;' : 'color: black;'"
                                      :color="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'red' : detail.status === 'Disetujui' ? 'green' : detail.status === 'Diproses' ? 'blue' : detail.status === 'Diterima' ? 'grey lighten-3' : 'yellow'"
                                    >
                                      {{ detail.status }}
                                    </v-chip>
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-card flat style="background: #FFF8E1; border-radius: 10px;" height="100%">
                            <v-card-text>
                              <div>
                                Tanggal Pengadaan
                              </div>
                              <div class="fs-16 font_weight_600 black_one">
                                {{ detail.date | date }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <!-- <v-card
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-card-text>
                      <div class="d-flex">
                        <div class="mb-5">
                          <div>
                            No. Permintaan
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.number }}
                          </div>
                        </div>
                        <div class="mb-5 ml-auto">
                          <div>

                            <v-chip
                              class="ma-2"
                              :style="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'color: white;' : detail.status === 'Disetujui' ? 'color: white;' : detail.status === 'Diproses' ? 'color: white;' : 'color: black;'"
                              :color="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'red' : detail.status === 'Disetujui' ? 'green' : detail.status === 'Diproses' ? 'blue' : detail.status === 'Diterima' ? 'grey lighten-3' : 'yellow'"
                            >
                              {{ detail.status }}
                            </v-chip>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="mb-5">
                          <div>
                            Tanggal Pengadaan
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.date | date }}
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card> -->
  
                  <!-- <v-card flat
                    v-if="detail_item.length < 1">
                    <v-card-text
                      class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="mt-3 fs-18">
                          Belum Ada Item
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
  
                  <div class="mt-5" v-if="detail_item.length > 0">
                    <div v-for="(item, index) in detail_item" :key="index">
                      <v-card flat class="mb-5" style="    background: #f0f8ff80; border-radius: 10px; border: 1px solid #f1f1f1;">
                        <v-card-text>
                          <div class="d-flex">
                            <div>
                              <div class="fs-16 font-weight-bold black_one">
                                {{ items[index].name_label }}
                              </div>
                              <div>
                                Kategori: <span class="font_weight_600">{{ items[index].category_item_name }}</span>
                              </div>
                              <div>
                                Harga Beli: <span class="font_weight_600">{{ items[index].purchase_price | price }} / {{ item.satuan }}</span>
                              </div>
                              <v-img 
                                class="mr-auto mt-2"
                                contain
                                alt="vuetify"
                                :width="50"
                                :height="50"
                                :src="items[index].image_url">
                              </v-img>
                            </div>
  
                            <div class="ml-auto text-right">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                  
                                    @click="dialog.delete = true; selected = index;"
  
                                    v-bind="attrs"
                                    v-on="on"
  
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0 mb-2"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>
                                
                                <span>Hapus</span>
                              </v-tooltip>
  
                              
                            </div>
                            
                          </div>
  
                          <v-row class="mt-4">
                            <v-col cols="4" class="py-0">
                              <div>
                                Harga Beli
                              </div>
                            </v-col>
                            <v-col cols="4" class="py-0">
                              <div>
                                Quantity
                              </div>
                            </v-col>
                            <v-col cols="4" class="text-right py-0">
                              <div>
                                Total
                              </div>
                            </v-col>
  
                            <v-col class="py-0" cols="4">
                              <div class="fs-16 font_weight_600 black_one">
                                {{ items[index].purchase_price | price }} / {{ item.satuan }}
                              </div>
                            </v-col>
                            <v-col class="py-0" cols="4">
                              <div class="fs-16 font_weight_600 black_one">
                                {{ item.qty*1 }}
                              </div>
                            </v-col>
                            <v-col cols="4" class="py-0 text-right">
                              <div class="fs-16 font_weight_600 black_one">
                                {{ (item.qty*1) * (items[index].purchase_price*1) | price }}
                              </div>
                            </v-col>
  
                            <v-col class="" cols="4">
                              <div>
                                <div>
                                  Supplier
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.supplier_name }}
                                </div>
                              </div>
                            </v-col>
  
                            <v-col class="py-0" cols="12">
                              <div>
                                <div>
                                  Catatan
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.note }}
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <v-row>
                      <v-col>
                        <div class="fs-17 font_weight_600 text-left black_one">
                          Total Perkiraan Modal Belanja
                        </div>
                      </v-col>
                      <v-col>
                        <div class="fs-17 font_weight_600 text-right black_one">
                          {{ total_nominal | price }}
                        </div>
                      </v-col>
                    </v-row>
                  </div> -->
                </div>
  
                <v-card flat class="mt-0">
                  <v-card-text class="pt-0">
                    <div class="mb-2 d-flex">
                      <div class="fs-16 font_weight_600 black_one">Data Item</div>
                      <div class="ml-auto">
                        <!-- <v-btn
                          :to="`/pembelian/approval-permintaan/add_item/${$route.params.id}`"
                          color="#4B4B4B"
                          elevation="0"
                          v-if="detail.status === 'Menunggu'"
                          class="body-2 white--text text-capitalize d-flex align-center"
                          style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                          <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                          
                          <span
                            class="ml-2">
                            Tambah
                          </span>
                        </v-btn> -->
                      </div>
                    </div>
                    <div>
                      <div class="d-flex align-center black--text">
                        <div class="fs-13 font_weight_600">
                          Total Perkiraan Belanja
                        </div>
                        <div class="font-weight-bold fs-15 ml-2">
                          : {{ total_nominal | price }}
                        </div>
                      </div>
                    </div>

                    <v-row>
                      <v-col 
                        cols="12"
                        class="py-0">
                        <v-card 
                          flat
                          style="border-radius: 10px; border: 1px solid #E7E7E7;">
                          <v-data-table
                            v-model="selected.row"
                            ref="table-grid"
                            class="table-grid"
                            :height="`calc(100vh - ${pagination.total_data > 0 ? '480px' : '248px'})`"
                            :show-select="checkbox"
                            :single-select="true"
                            :loading="process.load"
                            loading-text="Sedang memuat data . . ."
                            loader-height="5"
                            no-results-text="Belum ada data"
                            :options.sync="options"
                            :headers="configHeaders"
                            :items="list"
                            :items-per-page="100"
                            item-key="id"
                            @click:row="rowClick"
                            @toggle-select-all="handleToggleAll($event)"
                            @dblclick:row="doubleClick"
                            hide-default-footer>
                            <template
                              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                                v-slot:[`item.${header.value}`]="{ value, index }">
                              <div
                                v-bind:key="header.value">
                                <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                  {{ rowFormat(header.format, value) }} 
                                </div>
    
                                <div v-if="header.format === 'link'"
                                  class="cursor-pointer">
                                  
                                </div>
                  
                                <div v-if="header.format === 'regex'">
                                  <span
                                    class="two-line">
                                    {{ rowFormat(header.format, value) }}
                                  </span>
                                </div>
                  
                                <div v-if="header.format === 'image'"
                                  class="ma-4">
                                  <v-avatar
                                    size="60"
                                    tile
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <v-img 
                                      contain
                                      width="100%"
                                      height="100%"
                                      alt="POS Amanata" 
                                      :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                      class="ma-auto">
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height"
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            size="20"
                                            indeterminate 
                                            :color="set_color">
                                          </v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </v-avatar>
                                </div>
    
                                <div v-if="header.format === 'image_potrait'"
                                  class="ma-4">
                                  <v-img 
                                    contain
                                    width="100"
                                    height="125"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                    class="ma-auto"
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </div>
    
                                <div v-if="header.format === 'image_landscape'"
                                  class="ma-4">
                                  <v-img 
                                    contain
                                    width="200"
                                    height="125"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                    class="ma-auto"
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </div>
    
                                <div v-if="header.format === 'action'">
    
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="detail.status === 'Menunggu' ? toEdit(index) : ''"
    
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="detail.status !== 'Menunggu'"
    
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="blue"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-square-edit-outline</v-icon>
                                      </v-btn>
                                    </template>
    
                                    <span>Ubah</span>
                                  </v-tooltip>
    
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="detail.status === 'Menunggu' ? toDelete(value) : ''"
    
                                        v-bind="attrs"
                                        v-on="on"
    
                                        min-width="24" min-height="24"
                                        :disabled="detail.status !== 'Menunggu'"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>
    
                                    <span>Hapus</span>
                                  </v-tooltip>
                                </div>
                              </div>
                            </template>
    
                            <template v-slot:[`item.index`]="{ index }">
                              {{ lastIndex + index }}
                            </template>
    
                            <v-progress-linear 
                              v-show="process.load" 
                              slot="progress" 
                              color="white" 
                              indeterminate>
                            </v-progress-linear>
                          </v-data-table>
    
                          <pagination v-if="pagination.total_data > 0"
                            @changePage="fetch($event)" 
                            @reloadPage="fetch($event)" 
                            :model="pagination" :display="paginationList"/>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat>
                <v-card-actions
                  class="px-4">
                  <v-spacer/>

                  <v-btn
                    @click="dialog.status = true; message.success = ''; message.error = ''; message.status = 'setujui';"
                    :disabled="process.form"
                    v-if="detail.status === 'Menunggu'"
                    color="indigo"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-check-circle
                    </v-icon>

                    <span
                      class="ml-2">
                      Disetujui
                    </span>
                  </v-btn>

                  <v-btn
                    @click="dialog.status = true; message.success = ''; message.error = ''; message.status = 'tolak';"
                    :disabled="process.form"
                    v-if="detail.status === 'Menunggu'"
                    color="orange"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-cancel
                    </v-icon>

                    <span
                      class="ml-2">
                      Ditolak
                    </span>
                  </v-btn>
                  
                  <v-btn
                    to="/pembelian/approval-permintaan"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-progress-close
                    </v-icon>

                    <span
                      class="ml-2">
                      Kembali
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,

          role: false,
          delete: false,
          form: false,
          status: false
        },
        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},
        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          form: ''
        },

        form: {
          id: '',
          qty: '',
          note: '',
          supplier_id: ''
        },
        supplier: [],
        total: 0,

        lastIndex: 0,
        limit: 20,
        total_nominal: 0,
        detail: {},
        detail_item: [],
        items: [],
        // selected: 0,
        
        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false
        },
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    beforeMount () {
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/pembelian/request/data`, { params })
        .then(response => {
          let res = response.data

          // this.process.load = false
          this.fetch()

          if (res.status === 200) {
            this.detail = res.results.data[0]
          }
        })
      },
      formatPrice(value) {
        let val = (value/1)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          request_id: this.$route.params.id
        }

        await get(`pos/pembelian/request/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            console.log(res.results.data)
            this.items = []
            // this.detail_item = res.results.data
            this.detail_item = []
            res.results.data.map((item) => {
              this.detail_item.push({ 
                ...item,
                qty_satuan: `${item.qty*1} / ${item.satuan}`,
                qty: item.qty*1,
                harga_satuan: this.formatPrice(item.purchase_price*1) + ' / ' + item.satuan,
                total: (item.qty*1) * (item.purchase_price*1),
              })
            })
            // this.detail_item.map((item) => {
            //   this.fetchItem(item.item_id)
            // })
            // for (let i = 0; i < this.detail_item.length; i++) {
            //   this.fetchItem(this.detail_item[i].item_id)
            // }

            this.headers = [
              {
                text: 'Aksi',
                // width: '180px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Item',
                width: '100%',
                value: 'item_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Harga Beli',
                width: '200px',
                value: 'harga_satuan',
                freeze: false,
                hide: false,
              },
              {
                text: 'Qty',
                width: '150px',
                value: 'qty_satuan',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Supplier',
              //   width: '200px',
              //   value: 'supplier_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Sub Total',
                width: '200px',
                value: 'total',
                freeze: false,
                hide: false,
                format: 'number'
              },
              {
                text: 'Catatan',
                // width: '150px',
                value: 'note',
                freeze: false,
                hide: false
              },
            ]

            this.total_nominal = 0
  
            this.list = this.detail_item
            this.detail_item.map((item) => {
              this.total_nominal += (item.qty*1) * (item.purchase_price*1)
            })
              
  
            // this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
            this.process.load = false

          }
        })
      },
      async fetchItem (id) {
        let params = {
          limit: 100000,
          outlet_id: this.outlet.outlet_id,
          id: id
        }
        
        await get('pos/pembelian/item/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.detail_item.map((item) => {
            //   if(item.id === id) {
                this.items.push(res.results.data[0])
              this.detail_item.map((item, index) => {
                if(item.item_id === id) {
                  this.detail_item[index].name_label = res.results.data[0].name_label
                  // this.detail_item[index].category_item_name = res.results.data[0].category_item_name
                  // this.detail_item[index].satuan = res.results.data[0].satuan
                  // this.detail_item[index].purchase_price = res.results.data[0].purchase_price
                  // this.detail_item[index].total = (res.results.data[0].purchase_price*1) * item.qty
                  // this.detail_item[index].harga_satuan = this.formatPrice(res.results.data[0].purchase_price) + '/' + res.results.data[0].satuan
                  // this.total_nominal += (this.detail_item[index].qty*1) * (res.results.data[0].purchase_price*1)
                  if(index === this.detail_item.length - 1) {
                    this.process.load = false
                  }
                }
              })
  
              this.list = this.detail_item
              
  
            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
  
  
              
            // })
            // this.item = []
            // res.results.data.map((item) => {
            //   this.item.push({ 
            //     ...item,
            //     qty: 0,
            //     note_permintaan: '',
            //     total: 0,
            //     supplier_id: '',
            //     supplier: []
            //   })
            // })
            // this.item.map((item) => {
            //   this.fetchSupplier(item.id)
            // })
            // this.item = res.results.data
          }
        })
      },
      toEdit(index) {
        console.log(index)
        this.form.id = this.list[index].id
        this.form.qty = this.list[index].qty
        this.form.note = this.list[index].note
        this.form.supplier_id = this.list[index].supplier_id
        // this.fetchSupplier(this.list[index].item_id)
        this.dialog.form = true
        this.selected.form = index
      },
      async fetchSupplier (id) {
        let params = {
          limit: 100000,
          item_id: id
        }
        
        await get('pos/pembelian/item_supplier/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supplier = res.results.data
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // let url = this.form.id === '' ? 'pos/pembelian/category_item/add' : 'pos/pembelian/category_item/update'

          // SAVE TO REST API
          await post('pos/pembelian/request/update_item', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
              this.fetch(this.paginationList)

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async saveStatus () {
        this.message.error = ''

        this.process.form = true

        let params = {
          id: this.$route.params.id,
          status: this.message.status === 'setujui' ? 'Disetujui' : 'Ditolak'
        }

        await post(`pos/pembelian/request/approval`, { data: params })
        .then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.status = false

            this.fetchDetail()
            this.fetch(this.paginationList)
            this.dialog.snackbar = true
            this.message.success = res.message
            this.message.error = ''
          } else {
            this.message.error = res.message
          }
        })
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/pembelian/request/delete_item`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>